export default __webpack_public_path__ + "static/g104-9fb8e3214dc08451601ce590188f9baa.jpg";